import { Component, OnInit, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { of, Subject } from 'rxjs';
import { DatagridComponent } from '@farris/ui-datagrid';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { BsModalService } from '@farris/ui-modal';
import { VariableGridComponent } from '../variable-grid/variable-grid.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';
import { ActualParameter } from '../entities/execute-form.entity';

@Component({
  selector: 'lib-parameter-setting',
  templateUrl: './parameter-setting.component.html',
  styleUrls: ['./parameter-setting.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class ParameterSettingComponent implements OnInit {

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  idField: 'Name' | 'code' = 'Name';

  private _mode: 'bpmn' | 'usual' = 'bpmn';
  set mode(m: 'bpmn' | 'usual') {
    this._mode = m;
    if (m === 'bpmn') {
      this.idField = 'Name';
      this.cols = [
        { field: 'Name', width: 50, title: this.localePipe.transform('component.executeForms.code') },
        { field: 'Tag', width: 50, title: this.localePipe.transform('component.executeForms.tag'),  formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'text', data: this.valueTypeCollection }
        },
        editor: {
          type: EditorTypes.COMBOLIST,
          options: {
            valueField: 'value', textField: 'text', data: this.valueTypeCollection, idField: 'value', panelHeight: 'auto', enableClear: false,
            selectChange: (e) => {
              this.valueTypeChange(e);
            }}
        } },
        {
          field: 'Value', width: 100, title: this.localePipe.transform('component.executeForms.value'),
          editor: {
            type: 'input-group',
            options: {
              groupText: '<i class="f-icon f-icon-lookup"></i>',
              editable: false,
              clickHandle: (e) => {
                e.formControl.setValue(e.instance.value ? e.instance.value : '');
                this.showExprHelp(e);
              },
              clear: (e) => {
                console.log('clear', e);
              }
            }
          }
        }
      ];
      if(this.parameters && this.parameters.length > 0 && (this.parameters as ActualParameter[]).some(p => p.NameDisPlay != undefined && p.NameDisPlay != null && p.NameDisPlay.length > 0)) {
        this.cols.splice(1,0,{ field: 'NameDisPlay', width: 50, title: this.localePipe.transform('component.executeForms.paramName') });
      }
    } else {
      this.idField = 'code';
      this.cols = [
        { field: 'code', width: 50, title: this.localePipe.transform('component.executeForms.code') },
        { field: 'name', width: 50, title: this.localePipe.transform('component.executeForms.name') },
        {
          field: 'value', width: 100, title: this.localePipe.transform('component.executeForms.value') ,
          editor: {
            type: 'input-group',
            options: {
              groupText: '<i class="f-icon f-icon-lookup"></i>',
              editable: false,
              clickHandle: (e) => {
                e.formControl.setValue(e.instance.value ? e.instance.value : '');
                this.showExprHelp(e);
              },
              clear: (e) => {
                console.log('clear', e);
              }
            }
          }
        }
      ];
    }
  }

  get mode() {
    return this._mode;
  }
  submit = new Subject<any>();
  cancel = new Subject();
  formTypeCollection = [
    { text: this.localePipe.transform('component.executeForms.processEmbeddedForm'), value: '0' },
    { text: this.localePipe.transform('component.executeForms.formEmbedProcess'), value: '1' },
  ];

  public valueTypeCollection = [
    { text: this.localePipe.transform('component.executeForms.variable'), value: 'variable' },
    { text: this.localePipe.transform('component.executeForms.constant'), value: 'constant' },
    { text: this.localePipe.transform('component.executeForms.expression'), value: 'expression' }
  ];


  cols = new Array();

  parameters = new Array();

  formType = this.formTypeCollection[0].value;

  showFormType = false;

  allParameters = new Array();

  constructor(
    private expr: ExpressionService,
    private designerState: ProcessDesignerUIState,
    private resolver: ComponentFactoryResolver,
    private modalService: BsModalService,
    public injector: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  showExprHelp(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }

    this.expr.addExpressionText(e.instance.value);

    this.expr.buildExpression().then((d: string) => { // 编辑器返回值
      if (d) {
        e.formControl.setValue(d);
        e.instance.cd.detectChanges();
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  clickOK() {
    this.grid.endCellEdit();
    this.submit.next({ parameters: this.parameters, formType: this.formType });
  }

  clickCancel() {
    this.cancel.next();
  }

  valueTypeChange(e: any) {
    const param = this.parameters.find(p => p.Name === e.rowData.Name);
    param.Value = '';
  }

  beforeEdit = (param: any) => {
    if (this.mode === 'usual') {
      return of(true);
    } else {
      if (param.column.field === 'Value') {
        const rowData = param.rowData as any;
        switch (rowData.Tag) {
          case 'expression':
            param.column.editor =  {
              type: 'input-group',
              options: {
                groupText: '<i class="f-icon f-icon-lookup"></i>',
                editable: false,
                clickHandle: (e) => {
                  e.formControl.setValue(e.instance.value ? e.instance.value : '');
                  this.showExprHelp(e);
                },
                clear: (e) => {
                  console.log('clear', e);
                }
              }
            };
            break;
          case 'variable':
            param.column.editor =  {
              type: 'input-group',
              options: {
                groupText: '<i class="f-icon f-icon-lookup"></i>',
                editable: false,
                clickHandle: (e) => {
                  this.selectVariable(e);
                },
                clear: (e) => {
                  console.log('clear', e);
                }
              }
            };
            break;
          case 'constant':
            param.column.editor = { type: EditorTypes.TEXTBOX, options: {} };
            break;
        }
      }
      return of(true);
    }
  }

  selectVariable(e: any) {
    const compFactory = this.resolver.resolveComponentFactory(VariableGridComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.data = this.allParameters; // 目前只能根据元数据类型过滤，后续添加标签过滤
    const modalConfig = {
      title: this.localePipe.transform('component.executeForms.variable'),
      width: 460,
      height: 450,
      showButtons: true,
      buttons: compRef.instance.buttonRef
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.submit.subscribe(data => {
      if (data) {
        e.formControl.setValue(data.key);
        e.instance.cd.detectChanges();
      }
      dialog.close();
    });
    compRef.instance.cancel.subscribe( data => dialog.close());
  }
}
